import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import AuthLoadingScreen from './AuthLoadingScreen';

export default function ProtectedRoute({ children, role }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) return <AuthLoadingScreen />;

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
  }

  if (role === 'staff') {
    // Staff gate: admin + ops can access /admin/*.
    if (user.role !== 'nexsav_admin' && user.role !== 'ops') {
      return <Navigate to={defaultPathFor(user)} replace />;
    }
    return children;
  }

  if (role === 'nexsav_admin' && user.role !== 'nexsav_admin') {
    return <Navigate to={defaultPathFor(user)} replace />;
  }

  if (role === 'client' && user.role !== 'client') {
    return <Navigate to={defaultPathFor(user)} replace />;
  }

  if (role === 'media' && user.role !== 'media') {
    return <Navigate to={defaultPathFor(user)} replace />;
  }

  return children;
}

// Mirrors Login.jsx's defaultLandingFor — kept inline here so role-gate
// redirects don't bounce a Media-role user into /portal (a client-only
// surface) when they hit /admin or vice versa.
function defaultPathFor(user) {
  if (!user) return '/login';
  if (user.role === 'nexsav_admin' || user.role === 'ops') return '/admin';
  if (user.role === 'media') return '/media';
  return '/portal';
}
